<template>
    <section>
        <div class="filters">
            <el-row :gutter="10" class="w-100">
                <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="4">
                    <el-input v-model="query.keyword" size="small" clearable class="mt-1 w-100"
                              placeholder="Nhập mã, tên, số điện thoại"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="4">
                    <el-select v-model="query.department_id" size="small" class="mt-1 w-100" clearable filterable
                               placeholder="Lọc Team">
                        <el-option
                            v-for="item in department"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="4">
                    <el-select v-model="query.account_type_id" size="small" placeholder="Chọn chức vụ" clearable  class="mt-1 w-100">
                        <el-option v-for="item in filteredPositions" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="4">
                    <el-select v-model="query.level" clearable placeholder="Level" size="small" class="mt-1 w-100">
                        <el-option
                            v-for="item in levels"
                            :key="item.id"
                            :label="item.level"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="4">
                    <el-select v-model="query.year" placeholder="Lọc năm" size="small" class="mt-1 w-100">
                        <el-option v-for="y in years" :key="y" :label="'Năm ' + y" :value="y" />
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="4">
                    <el-select v-model="query.quarter" placeholder="Lọc quý" size="small" class="mt-1 w-100">
                        <el-option v-for="q in [1, 2, 3, 4]" :key="q" :label="'Quý ' + convertToRoman(q)" :value="q" />
                    </el-select>
                </el-col>
            </el-row>
        </div>

        <div class="charts-row">
            <div class="chart-col">
                <div v-if="loading" class="donut-skeleton">
                    <div class="circle"></div>
                    <div class="line"></div>
                </div>
                <ChartDonut v-else :series="donutStatus.series"
                            :labels="donutStatusLabels"
                            :colors="['#5b21b6', '#c4b5fd', '#22d3ee']" caption="Tỷ trọng tăng - giảm level" icon="people" />
            </div>

            <div class="chart-col">
                <div v-if="loading" class="donut-skeleton">
                    <div class="circle"></div>
                    <div class="line"></div>
                </div>
                <ChartDonut v-else :series="donutLevel.series" :labels="levelLabels"
                            :colors="['#c4b5fd', '#8b5cf6', '#f8a0d2', '#fbbe24', '#f97316', '#22d3ee', '#8b5cf6']"
                            caption="Tỷ trọng nhân sự tại các level" icon="users" />
            </div>
        </div>
        <div class="section-card">
            <TeamleadProgressTable :items="items" :loading="loading" @userIdOpentModal="openModal" />
        </div>
        <el-dialog
            class="responsive teacher-day"
            :visible.sync="outerVisible"
            :title="dialogTitle"
            @close="clearForm"
            :close-on-click-modal="false"
            destroy-on-close
            top="5vh"
            width="70%"
        >
            <div v-loading="dialogLoading" class="w-100">
                <el-tabs v-model="activeMonth" type="card">
                    <el-tab-pane
                        v-for="m in quarterMonths"
                        :key="m.month"
                        :name="String(m.month)"
                        :label="m.label"
                    >
                        <div>
                        <span style="font-weight: 700">Điểm trung bình: {{ totalScore[m.month] }} %</span>
                        </div>
                        <div class="mt-2">
                            <el-table
                                :data="(reviewFormByMonth[m.month] && reviewFormByMonth[m.month].criteria) ? reviewFormByMonth[m.month].criteria : []"
                                stripe
                                border
                                size="mini"
                                :row-key="'id'"
                                :span-method="(params) => criteriaSpanMethod(params, m.month)"
                            >
                                <el-table-column
                                    prop="criteria_name"
                                    label="Tiêu chí"
                                    min-width="200"
                                    show-overflow-tooltip
                                />
                                <el-table-column
                                    prop="task"
                                    label="Nhiệm vụ"
                                    min-width="120"
                                />
                                <el-table-column label="Loại tiêu chí" min-width="100">
                                    <template slot-scope="{ row }">
                                        {{ row.type == 1 ? 'Tháng' : 'Quý' }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Link báo cáo" min-width="240">
                                    <template slot-scope="{ row }">
                                        <div v-if="shouldShowQuarterHint(row, m.month)" class="text-center empty-row">
                                            <span style="font-style: italic">
                                                {{ quarterHintText }}
                                            </span>
                                        </div>
                                        <el-input
                                            v-else
                                            v-model="row.report_link"
                                            type="textarea"
                                            :rows="3"
                                            :disabled="!is_edit"
                                            placeholder="Nhập link báo cáo..."
                                            clearable
                                            @change="handleChangeLink(row.id, $event)"
                                        />
                                    </template>
                                </el-table-column>
                                <el-table-column label="Kết quả đạt thực tế" min-width="180">
                                    <template slot-scope="{ row }">
                                        <el-input-number
                                            v-model="row.score_actual"
                                            :min="0"
                                            :step="1"
                                            :controls="false"
                                            :value-on-clear="null"
                                            :disabled="!is_edit || !hasReportLink(row.report_link)"
                                            style="width: 100%"
                                            @change="handleChangeScore(row.id, $event)"
                                        /> <span class="absolute mt-2" style="margin-left: -20px">%</span>
                                    </template>
                                </el-table-column>

                                <el-table-column label="Kết quả KPI chỉ số " min-width="150">
                                    <template slot-scope="{ row }">
                                        <el-input-number
                                            v-model="row.score_conversion"
                                            :min="0"
                                            :step="1"
                                            :controls="false"
                                            :value-on-clear="null"
                                            disabled
                                            style="width: 100%"
                                        /> <span class="absolute mt-2" style="margin-left: -20px">%</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="Trạng thái" min-width="150">
                                    <template slot-scope="{ row }">
                                    <el-button
                                        v-if="row.status"
                                        :type="taskMeta(row.status).type"
                                        size="mini"
                                    >
                                        {{ taskMeta(row.status).label }} <span v-if="row.status != 2">{{ row.count_level }} bậc</span>
                                    </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>

        </el-dialog>
    </section>

</template>

<script>
import ChartDonut from './chart/ChartDonut.vue'
import WarningPanel from './warning/WarningPanel.vue'
import TeamleadProgressTable from './table/TeamleadProgressTable.vue'
import {GET_DEPARTMENT_BY_DEPARTMENT_HEAD} from "@/core/services/store/profile.module";

import {
    GET_PROGRESS_LEADER_LIST,
    GET_LIST_LEVEL
} from "@/core/services/store/approve-team-level/approveTeamLevel.module";
import {mapGetters} from "vuex";
import {
    GET_TEAMLEAD_REVIEW,
    SCORE_CONVERTION,
    UPDATE_TEAMLEAD_REVIEW
} from "@/core/services/store/level/level.module";


export default {
    name: 'TeamleadProgressTab',
    components: { ChartDonut, WarningPanel, TeamleadProgressTable },
    data() {
        const now = new Date().getFullYear();
        return {
            query: { keyword: '', department_id: null, account_type_id: null, level: null, year: now, quarter: 1 },
            department: [],
            levels: [],
            years: [],
            items: [],
            loading: false,
            donutStatus: { series: [100], options: {} },
            donutStatusLabels: ['Chưa có dữ liệu'],
            donutLevel: { series: [100], options: {} },
            levelLabels: ['Chưa có dữ liệu'],
            showWarning: true,
            outerVisible: false,
            showDetailModal: false,
            selectedWarning: null,
            _debounceTimer: null,
            _skipQueryWatch: false,
            dialogLoading: false,
            saving: false,
            selectedUserForDialog: { userId: null, userName: '', year: null, quarter: 1 },
            dialogTitle: 'Kết quả chỉ số',
            activeMonth: '1',
            quarterMonths: [],
            reviewFormByMonth: {},
            // Keep raw keys so we can send back updated data in the format backend expects
            _reviewRawMonths: [],
            _reviewSource: null,
            positions: [
                {id: 32, name: 'Trưởng bộ phận'},
                {id: 16, name: 'Trưởng phòng'},
                {id: 34, name: 'Trưởng nhóm'},
            ],

            accountTypeMap: {
                32: [32,34], //Trưởng bộ phận
                16: [32,16,34], // Trưởng phòng
            },
            userId: '',
            totalScore: [],
            task_meta: {
                1: { type: 'info',  label: 'Không đạt' },
                2: { type: 'primary', label: 'Đạt' },
                3: { type: 'success', label: 'Vượt' },
            },
            is_edit: false,
            quarterHintText: 'Bạn chỉ cần nhập kết quả chỉ số này vào tháng cuối của quý',

        };
    },
    mounted() {
        this.getCurrentQuarterAndYear();
        this.getDepartmentByUserId(this.currentUser.id);
        this.getListLevel();
        this.initFromRoute();
    },
    watch: {
        // Khi user thay đổi filter -> update URL
        query: {
            deep: true,
            handler() {
                if (this._skipQueryWatch) return;
                if (this._debounceTimer) clearTimeout(this._debounceTimer);
                this._debounceTimer = setTimeout(() => {
                    this.updateRoute();
                    this.reload();
                }, 0);
            },
        },

        // Khi URL thay đổi (back/forward/tab switch) -> update filter
        '$route.query': {
            handler(newQuery) {
                if (newQuery.tab !== 'teamlead') return;
                this.applyRouteToQuery(newQuery);
            },
        },
    },
    methods: {
        clearForm() {
            this.dialogLoading = false;
            this.saving = false;
            this.selectedUserForDialog = { userId: null, userName: '', year: null, quarter: 1 };
            this.dialogTitle = 'Kết quả chỉ số';
            this.activeMonth = '1';
            this.quarterMonths = [];
            this.reviewFormByMonth = {};
            this.totalScore = [];
            this._reviewRawMonths = [];
            this._reviewSource = null;
        },
        openModal(payload) {
            this.is_edit = this.currentUser.id == payload?.userId;
            this.outerVisible = true;

            const userId = payload?.userId;
            this.userId = userId;
            const year = payload?.year;
            const quarter = payload?.quarter;
            const userName = payload?.userName ?? '';

            this.selectedUserForDialog = { userId, year, userName, quarter };
            this.dialogTitle = `Kết quả chỉ số: ${userName || 'Nhân sự'} - Quý ${this.convertToRoman(quarter)}/${year}`;

            this.buildEmptyQuarterForm(quarter);
            this.fetchTeamleadReview();
        },

        fetchTeamleadReview() {
            
            if (!this.selectedUserForDialog?.userId) return;
            this.dialogLoading = true;

            const payload = {
                user_id: this.selectedUserForDialog.userId,
                year: this.selectedUserForDialog.year,
                quarter: this.selectedUserForDialog.quarter,
            };

            this.$store.dispatch(GET_TEAMLEAD_REVIEW, payload)
                .then((res) => {
                    const reviewRaw = res?.data ?? res;
                    this._reviewSource = reviewRaw;

                    const months = this.extractMonthsArray(reviewRaw);
                    this._reviewRawMonths = Array.isArray(months) ? months : [];
                    this.fillQuarterFormFromRaw(this._reviewRawMonths);
                })
                .catch(() => {
                    // Nếu backend không trả đúng format, form vẫn rỗng để user vẫn có thể nhập
                    this.$notify.error({
                        title: 'Thất bại',
                        message: 'Không tải được dữ liệu review theo quý. Vui lòng thử lại.',
                        type: 'error',
                    });
                })
                .finally(() => {
                    this.dialogLoading = false;
                });
        },

        getQuarterMonths(quarter) {
            // Quarter -> months
            if (+quarter === 1) return [1, 2, 3];
            if (+quarter === 2) return [4, 5, 6];
            if (+quarter === 3) return [7, 8, 9];
            if (+quarter === 4) return [10, 11, 12];
            return [1, 2, 3];
        },

        buildEmptyQuarterForm(quarter) {
            const months = this.getQuarterMonths(quarter);
            this.quarterMonths = months.map((m) => ({
                month: m,
                label: `Tháng ${m}`,
            }));

            const form = {};
            months.forEach((m) => {
                form[m] = {
                    criteria: [],
                    __rawMonthRef: null,
                };

                this.$set(this.totalScore, m, 0);
            });
            this.reviewFormByMonth = form;
            this.activeMonth = String(months[0]);
        },

        extractMonthsArray(reviewRaw) {

            if (!reviewRaw) return [];
            // Backend đôi khi trả thẳng dạng array: [{month:1, criteria:[...]}, ...]
            if (Array.isArray(reviewRaw)) return reviewRaw;

            
            const candidates = [
                reviewRaw?.months,
                reviewRaw?.data?.months,
                reviewRaw?.data?.results_months,
                reviewRaw?.details,
                reviewRaw?.data_detail,
                reviewRaw?.month_results,
                reviewRaw?.results,
                reviewRaw?.data?.details,
            ];

            const found = candidates.find((c) => Array.isArray(c));
            return Array.isArray(found) ? found : [];
        },

        findExistingKey(obj, keys) {
            if (!obj) return null;
            for (const k of keys) {
                if (obj[k] !== undefined) return k;
            }
            return null;
        },

        fillQuarterFormFromRaw(monthObjects) {
            const months = Array.isArray(monthObjects) ? monthObjects : [];

            this.quarterMonths.forEach(({ month }) => {
                const monthObj = months.find((x) => {
                    const n =
                        Number(x?.month ?? x?.month_number ?? x?.period_month ?? x?.m ?? x?.index);
                    return n === Number(month);
                });

                if (!monthObj) return;
                const criteria = Array.isArray(monthObj.criteria) ? monthObj.criteria : [];

                if (this.reviewFormByMonth[month]) {
                    // Normalize fields so `el-input-number` / `el-input` always bind safely
                    criteria.forEach((c) => {
                        if (c.score_standard === undefined) this.$set(c, 'score_standard', 0);
                        if (c.score_conversion === undefined) this.$set(c, 'score_conversion', null);
                        if (c.score_actual === undefined) this.$set(c, 'score_actual', null);
                        if (c.report_link === undefined || c.report_link === null) this.$set(c, 'report_link', '');

                        // Coerce to expected types for Element UI inputs
                        if (c.score_standard !== null && c.score_standard !== undefined && c.score_standard !== '') {
                            this.$set(c, 'score_standard', Number(c.score_standard));
                        } else {
                            this.$set(c, 'score_standard', 0);
                        }
                        if (c.score_conversion === null || c.score_conversion === undefined || c.score_conversion === '') {
                            this.$set(c, 'score_conversion', undefined);
                        } else {
                            this.$set(c, 'score_conversion', Number(c.score_conversion));
                        }
                        if (c.score_actual === null || c.score_actual === undefined || c.score_actual === '') {
                            this.$set(c, 'score_actual', undefined);
                        } else {
                            this.$set(c, 'score_actual', Number(c.score_actual));
                        }

                        if (c.report_link !== null && c.report_link !== undefined) {
                            this.$set(c, 'report_link', String(c.report_link));
                        } else {
                            this.$set(c, 'report_link', '');
                        }
                    });

                    this.$set(this.reviewFormByMonth[month], 'criteria', criteria);
                    this.$set(this.reviewFormByMonth[month], '__rawMonthRef', monthObj);

                    // Recalculate total for this month
                    this.calculateTotalScoreForMonth(month);
                }
            });
        },

        calculateTotalScoreForMonth(month) {
            const criteria = this.reviewFormByMonth?.[month]?.criteria || [];
            const sum = criteria.length ? criteria.reduce((acc, c) => acc + (Number(c?.score_conversion) || 0), 0) / criteria.length : 0;
            this.$set(this.totalScore, month, sum.toFixed(2));
        },

        calculateTotalScoreForQuarter() {
            (this.quarterMonths || []).forEach(({ month }) => this.calculateTotalScoreForMonth(month));
        },

        isValidHttpUrl(value) {
            if (!value) return false;
            try {
                const url = String(value).trim();
                return /^https?:\/\//i.test(url);
            } catch (e) {
                return false;
            }
        },
        hasReportLink(value) {
            return !!String(value || '').trim();
        },
        shouldShowQuarterHint(row, month) {
            const isQuarterType = Number(row?.type) == 2;
            const isScoreActualEmpty = row?.score_actual === null || row?.score_actual === undefined;
            const firstTwoMonths = (this.quarterMonths || [])
                .slice(0, 2)
                .map((item) => Number(item.month));
            const isInFirstTwoMonths = firstTwoMonths.includes(Number(month));


            return isQuarterType && isScoreActualEmpty && isInFirstTwoMonths && (currentUser.id == row?.user_id);
        },
        /** Colspan 4 cột: Link báo cáo → Trạng thái (index 3–6) */
        criteriaSpanMethod({ row, columnIndex }, month) {
            const LINK_COL = 3;
            const SPAN = 4;
            if (this.shouldShowQuarterHint(row, month)) {
                if (columnIndex === LINK_COL) return [1, SPAN];
                if (columnIndex > LINK_COL && columnIndex < LINK_COL + SPAN) return [0, 0];
            }
            return [1, 1];
        },
        convertToRoman(num) {
            const romanNumerals = { 1: 'I', 2: 'II', 3: 'III', 4: 'IV' };
            return romanNumerals[num] || num;
        },

        calculateLevelCounts(dataCurrentLevel) {
            const levelMap = {
                'trainee': 0,
                'junior1': 1,
                'junior2': 2,
                'member1': 3,
                'member2': 4,
                'senior1': 5,
                'senior2': 6
            };
            
            const levelCounts = [0, 0, 0, 0, 0, 0, 0];
            
            if (!dataCurrentLevel) return levelCounts;
            
            Object.entries(dataCurrentLevel).forEach(([levelName, count]) => {
                const normalized = levelName.toLowerCase().trim();
                const level = normalized.match(/(senior|junior|member|trainee)/)?.[1];
                const number = normalized.match(/[12]/)?.[0];
                
                const normalizedBands = level === 'trainee' ? 'trainee' : `${level}${number || '2'}`;
                const index = levelMap[normalizedBands];
                
                if (index !== undefined) {
                    levelCounts[index] += count;
                }
            });
            
            return levelCounts;
        },
        getCurrentQuarterAndYear() {
            const now = new Date();
            const y = now.getFullYear();
            const s = 2025;
            const currentQuarter = (now.getMonth() / 3 | 0) + 1;

            const rq = this.$route?.query || {};
            if (rq.tab !== 'teamlead' || !rq.quarter) {
                this.query.quarter = currentQuarter;
            }

            this.query.year = (this.query.year && this.query.year >= s && this.query.year <= y) ? this.query.year : y;
            this.years = Array.from({ length: Math.max(1, y - s + 1) }, (_, i) => s + i);
        },
        clearData() {
            this.items = [];
        },

        reload() {
            this.clearData();
            this.loading = true;
            const payload = {
                keyword: this.query.keyword,
                department_id: this.query.department_id,
                account_type_id: this.query.account_type_id,
                current_level: this.query.level,
                year: this.query.year,
                quarter: this.query.quarter,
                level_type: 2,
            };
            this.$store.dispatch(GET_PROGRESS_LEADER_LIST, payload).then((res) => {
                const s = res.data;
                this.items = s.data_detail;
                const data_level = s.data_level_up_and_down;

                // Tỷ trọng tăng giảm level
                const upLevel = data_level?.up_level || 0;
                const keepLevel = data_level?.keep_level || 0;
                const downLevel = data_level?.down_level || 0;
                const default_kepp = upLevel == 0 && downLevel == 0 && keepLevel == 0;
                
                if (!default_kepp) {
                    this.donutStatus.series = [upLevel, keepLevel, downLevel];
                    this.donutStatusLabels = ['NS tăng level', 'NS giữ nguyên level', 'NS giảm level'];
                } else {
                    this.donutStatus.series = [0, 100, 0];
                    this.donutStatusLabels = ['NS tăng level', 'NS giữ nguyên level', 'NS giảm level'];
                }

                // Tỷ trọng nhân sự tại các level
                const counts = this.calculateLevelCounts(s.data_current_level);
                const totalCounts = counts.reduce((sum, v) => sum + (Number(v) || 0), 0);
                if (totalCounts > 0) {
                    this.levelLabels = ['Trainee', 'Junior 1', 'Junior 2', 'Member 1', 'Member 2', 'Senior 1', 'Senior 2'];
                    this.donutLevel.series = counts;
                } else {
                    this.levelLabels = ['Chưa có dữ liệu'];
                    this.donutLevel.series = [100];
                }
            }).finally(() => {
                this.loading = false;
            });
        },

        getDepartmentByUserId(user_id) {
            this.$store.dispatch(GET_DEPARTMENT_BY_DEPARTMENT_HEAD, { user_id })
                .then((res) => { this.department = res.data; })
                .catch(() => {});
        },

        getListLevel() {
            this.$store.dispatch(GET_LIST_LEVEL, { type: 1 })
                .then((res) => { this.levels = res.data; })
                .catch(() => {});
        },

        // Khởi tạo từ URL (chỉ gọi 1 lần khi mount)
        initFromRoute() {
            const q = this.$route.query;
            if (q.tab === 'teamlead') {
                this.applyRouteToQuery(q);
            } else {
                this.updateRoute();
            }
            this.reload();
        },

        // Áp dụng URL params vào query (Route -> State)
        applyRouteToQuery(routeQuery) {
            this._skipQueryWatch = true;
            const toInt = v => (v === undefined || v === null || v === '' ? null : parseInt(v, 10));

            this.query.keyword = routeQuery.keyword || '';
            this.query.department_id = toInt(routeQuery.department_id);
            this.query.account_type_id = toInt(routeQuery.account_type_id);
            this.query.level = toInt(routeQuery.level);
            this.query.year = toInt(routeQuery.year) || this.query.year;
            this.query.quarter = toInt(routeQuery.quarter) || this.query.quarter;

            this.$nextTick(() => {
                this._skipQueryWatch = false;
            });
        },

        // Cập nhật URL từ query (State -> Route)
        updateRoute() {
            const newQuery = {
                keyword: this.query.keyword || undefined,
                department_id: this.query.department_id || undefined,
                account_type_id: this.query.account_type_id || undefined,
                level: this.query.level || undefined,
                year: this.query.year || undefined,
                quarter: this.query.quarter || undefined,
                tab: 'teamlead'
            };

            // Chỉ update nếu khác với route hiện tại
            const currentQuery = this.$route.query;
            if (JSON.stringify(newQuery) !== JSON.stringify(currentQuery)) {
                this.$router.replace({ query: newQuery }).catch(() => {});
            }
        },
      
        handleChangeScore(id, score)
        {
            if (score === null || score === undefined || score === '') return;
            let payload = {
                id: id,
                score_actual: score,
            };

            // Recalculate instantly from local edited value
            this.calculateTotalScoreForQuarter();

            this.$store.dispatch(SCORE_CONVERTION, payload)
                .then((res) => {
                    this.fetchTeamleadReview();
                    this.$notify.success({
                        title: 'Thành công',
                        message: 'Đã lưu thay đổi kết quả chỉ số.',
                        type: 'success',
                    });
                });
        },
        handleChangeLink(id, report_link)
        {
            if (report_link === null || report_link === undefined || report_link === '') return;
            let payload = {
                id: id,
                report_link: report_link,
            };

            this.$store.dispatch(UPDATE_TEAMLEAD_REVIEW, payload)
                .then((res) => {
                    this.$notify.success({
                        title: 'Thành công',
                        message: 'Đã lưu thay đổi link báo cáo.',
                        type: 'success',
                    });
                });
        },
        taskMeta(status) {
            return this.task_meta[status] || '';
        }
    },
    computed: {
        ...mapGetters(['currentUser']),
        filteredPositions() {
            let accountTypeIid = this.currentUser.account_type?.id ?? 0;
            if (!accountTypeIid) return this.positions;
            let ids = this.accountTypeMap[accountTypeIid] || [];
            return this.positions.filter(p => ids.includes(p.id));
        },
        quarterLabel() {
            const q = this.selectedUserForDialog?.quarter ?? this.query.quarter;
            const y = this.selectedUserForDialog?.year ?? this.query.year;
            return `Quý ${this.convertToRoman(q)}/${y}`;
        },
    },
};
</script>

<style lang="scss" scoped>
.filters {
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.filters .el-col {
    margin-bottom: 8px;
}

.charts-row {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    align-items: start;
    margin-bottom: 16px;
    width: 100%;
}

.chart-col {
    flex: 1;
    background: transparent;
    border: 0;
    padding: 0 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.donut-skeleton {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 8px 0;
}

.donut-skeleton .circle {
    width: 220px;
    height: 220px;
    border-radius: 50%;
    background: linear-gradient(90deg, #f3f4f6 25%, #ede9fe 50%, #f3f4f6 75%);
    background-size: 400% 100%;
    animation: shimmer 1.2s ease-in-out infinite;
}

.donut-skeleton .line {
    width: 60%;
    height: 14px;
    border-radius: 7px;
    background: linear-gradient(90deg, #f3f4f6 25%, #ede9fe 50%, #f3f4f6 75%);
    background-size: 400% 100%;
    animation: shimmer 1.2s ease-in-out infinite;
}

@keyframes shimmer {
    0% { background-position: 100% 0; }
    100% { background-position: 0 0; }
}

@media (min-width: 1024px) {
    .charts-row {
        grid-template-columns: 1fr 1fr;
    }
}

@media (min-width: 1280px) {
    .charts-row {
        width: 66.67%;
    }
}

.warning-toggle {
    position: absolute;
    top: 70px;
    right: 10px;
    z-index: 1001;
}

.ring-icon {
    position: relative;
    cursor: pointer;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ring-icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    transform: rotate(15deg);
    transition: transform 0.3s ease;
}

.ring-icon:hover img {
    transform: rotate(15deg) scale(1.1);
}

.notification-badge {
    position: absolute;
    top: 4px;
    right: 0;
    background: #ef4444;
    color: white;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 600;
}

.section-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 24px;
    overflow: hidden;
}

.styled-link {
    color: rgba(0, 102, 255, 1);
    font-weight: 600;
    cursor: pointer;
}

.styled-link:hover {
    text-decoration: underline !important;
}

</style>
